import React from 'react';
import './Content.scss';
import { useSystemDevice } from '../../hooks/useSystemDevice';
import KiteCupRichSection from './RichSection';
import KiteCupTextSection from './TextSection';

export interface Props {
  className?: string;
}

interface SectionData {
  gridData?: [string, string][];
  imageSrc?: string;
  subtitle?: string;
  text?: string | string[];
  title?: string;
}

const KiteCupContent: React.FC<Props> = (props) => {
  const systemDevice = useSystemDevice();
  const scope = 'KiteCupContent';

  const className = [scope, `${scope}--${systemDevice}`, props.className]
    .filter((className) => className)
    .join(' ');

  const richSections: SectionData[] = [
    {
      imageSrc: `${process.env.PUBLIC_URL}/media/events/kite-cup/${systemDevice}/rich-1.jpg`,
      subtitle: 'One Minute With The Pro',
      title: 'PERFEKTER PLATZ',
      text: [
        'Stellen Sie sich vor, Sie sitzen in einem Defender, neben Ihnen ein Kitesurf-Profi. Sie tauschen Erfahrungen aus, teilen Geschichten. Ein unvergesslicher Moment, den Sie definitiv in ein paar einzigartigen Fotos festhalten sollten. Doch zögern Sie nicht, die Plätze sind begrenzt.',
        'DI, DO, SA 15:00-16:00*',
      ],
    },
    {
      imageSrc: `${process.env.PUBLIC_URL}/media/events/kite-cup/${systemDevice}/rich-2.jpg`,
      subtitle: 'Early Blackroll Session',
      title: 'GESTÄRKT. GESTARTET.',
      text: [
        'Die Sonne geht auf, Sie stehen am Strand und beginnen den Tag mit einem Faszien- und Fitnesstraining. Nach dem Sport genießen Sie einen Moment der Ruhe und einen frischen Energy-Smoothie. Ein kraftvoller und harmonischer Start mit Blackroll und unseren Athleten.',
        'DI, MI, DO, FR, SA, SO 9:00-10:00*',
      ],
    },
    {
      gridData: [
        ['DI', '19:00-22:00 – Selassie & DJ*'],
        ['DO', '19:00-22:00 – Selassie & DJ*'],
        ['SA', '19:00-22:00 – Aii PS*'],
      ],
      imageSrc: `${process.env.PUBLIC_URL}/media/events/kite-cup/${systemDevice}/rich-3.jpg`,
      subtitle: 'Live-Musik am Abend mit Aii PS & Selassie',
      title: 'DEFENDER Music Session',
      text: 'Die Sonne geht unter, die Musik wird lauter. Ein Defender steht im Hintergrund. Lassen Sie sich von ausgewählten Künstlern den Abend verschönern. Genießen Sie ein entspanntes Erlebnis, das den spannenden Tag ausklingen lässt.',
    },
    {
      imageSrc: `${process.env.PUBLIC_URL}/media/events/kite-cup/${systemDevice}/rich-4.jpg`,
      subtitle: 'Der Open Talk mit JAKLAR Positive Vibes',
      title: 'DEFENDER Inspiration Talk',
      text: [
        'Lassen Sie sich inspirieren und faszinieren. Gemeinsam mit JAKLAR Positive Vibes laden wir Sie zu lockeren Gesprächen mit den Stars der Kitesurf Community ein. Ein spannender Austausch, der auch Sie bestimmt bereichern wird.',
        'DI, DO 17:00-18:00*',
      ],
    },
    {
      imageSrc: `${process.env.PUBLIC_URL}/media/events/kite-cup/${systemDevice}/rich-5.jpg`,
      subtitle: 'Signierstunde mit Athleten des Kitesurf Worldcups',
      title: 'Signature Hour',
      text: [
        'Sichern Sie sich das perfekte Andenken an den Kitesurf Worldcup: Ein limitiertes Poster, signiert von einem Athleten des Kitesurf Worldcups. Ein schönes Andenken, das Sie immer an dieses einzigartige Erlebnis erinnern wird und das Sie mit Ihren Liebsten teilen können.',
        'MI, FR, SO 17:00-18:00*',
        '* Bitte beachten Sie, dass die Events wetterbedingt verschoben oder abgesagt werden können.',
      ],
    },
  ];

  return (
    <div className={className}>
      <div className={`${scope}-darkSection`}>
        <div className={`${scope}-content`}>
          <KiteCupTextSection
            text="Nach einjähriger Pause kehrt der Kitesurf World Cup dieses Jahr mit der Unterstützung von Defender zurück nach Sylt. Vom 22.08. bis zum 27.08.2023 können Sie die spannende und adrenalingeladene Jagd nach dem Defender Kite World Cup Titel hautnah miterleben. Am Brandenburger Strand in Westerland treffen sich die besten Kitesurfer der Welt. Dort kämpfen Sie mit spektakulären Tricks und Stunts um einen der begehrtesten Titel im Wassersport."
            title="Defender Kitesurf World Cup 22.-27-08.2023"
          />
        </div>
      </div>
      {richSections.map((section, index) => (
        <div className={`${scope}-content`} key={index}>
          <KiteCupRichSection
            className={`${scope}-richSection`}
            gridData={section.gridData}
            imageSrc={section.imageSrc}
            subtitle={section.subtitle}
            text={section.text}
            title={section.title}
          />
        </div>
      ))}
    </div>
  );
};

export default KiteCupContent;
